import React from 'react';
import { Section } from './ui/Section';
import { trackEvent } from '../utils/metaPixel';
import { smoothScrollToElement } from '../utils/scrollHelpers';
export function FinalCTA() {
  const scrollToPricing = () => {
    trackEvent('ViewContent', {
      content_name: 'final_cta_click',
      content_category: 'cta'
    });
    smoothScrollToElement('pricing');
  };
  return <Section variant="alt" data-id="element-70">
      <div className="text-center bg-red-50 border-2 border-red-500 rounded-lg p-6 max-w-2xl mx-auto" data-id="element-71">
        <p className="font-heading text-brand-primary font-bold mb-4" data-id="element-72">
          ⏰ El precio de lanzamiento sube pronto
        </p>
        <button onClick={scrollToPricing} className="bg-gradient-gold hover:opacity-90 text-brand-primary font-body font-bold text-xl py-4 px-10 rounded-lg transition-all hover:shadow-gold w-full md:w-auto animate-pulse" data-id="element-73">
          🚀 CONSEGUIR AHORA
        </button>
        <div className="mt-4 space-y-1 text-xs text-brand-textMuted" data-id="element-74">
          <div data-id="element-75">⚡ Acceso inmediato · 🛡️ Garantía 7 días · 💳 Desde 13,99€</div>
        </div>
      </div>
    </Section>;
}